import React from 'react';

import { requestPut, } from '../../../../../modules/request/index';
import { PLACEHOLDER_SCHOOL_NAMES, RadioButton, redirectTo, } from '../../../../Shared/index';
import SchoolSelector from '../../shared/school_selector.jsx';
import AssignActivityPackBanner from '../assignActivityPackBanner';

const schoolBuildingImgSrc = `${window.postbuildEnv.CDN_URL}/images/accounts/school-building.svg`

class SelectUSK12 extends React.Component {
  constructor(props) {
    super(props)

    this.state = { isCollege: false, }
  }

  componentDidMount() {
    document.title = 'Quill.org | Teacher Sign Up | Add School'
  }

  handleNonK12LinkClick = (e) => {
    window.location.href = "/sign-up/add-non-k12"
  }

  handleSelectK12Segment = () => this.setState({ isCollege: false, })

  handleSelectCollegeSegment = () => this.setState({ isCollege: true, })

  selectSchool = (idOrType) => {
    const { isAdmin, } = this.props
    // The "Skip this step" link in the school selection module trigger this function
    // with the argument 'non listed', while actually selecting a school triggers it
    // with a school identifier.
    requestPut(
      `${window.postbuildEnv.DEFAULT_URL}/select_school`,
      { school_id_or_type: idOrType, },
      (body) => {
        if (isAdmin) {
          redirectTo(PLACEHOLDER_SCHOOL_NAMES.includes(idOrType) ? '/finish_sign_up' : '/sign-up/verify-school')
        } else {
          redirectTo('/sign-up/add-teacher-info')
        }
      }
    )
  }

  renderInstitutionTypeSelection() {
    const { isAdmin, } = this.props
    const { isCollege, } = this.state
    const k12Label = isAdmin ? 'K-12 Administrator' : 'K-12 Teacher'
    const collegeLabel = isAdmin ? 'College Administrator' : 'College Instructor'
    const question = `Are you a ${k12Label} or a ${collegeLabel}?`

    return (
      <div aria-labelledby="institution-type-question" className="institution-type-selection" role="radiogroup">
        <p className="institution-type-question" id="institution-type-question">{question}</p>
        <div className="institution-type-options">
          <RadioButton label={k12Label} onClick={this.handleSelectK12Segment} selected={!isCollege} />
          <RadioButton label={collegeLabel} onClick={this.handleSelectCollegeSegment} selected={isCollege} />
        </div>
      </div>
    )
  }

  render() {
    const { isAdmin, } = this.props
    const { isCollege, } = this.state
    return (
      <main>
        <AssignActivityPackBanner />
        <div className="container account-form select-k12">
          <img alt="" className="top-graphic" src={schoolBuildingImgSrc} />
          <h1>Let&#39;s find your school or institution</h1>
          <p className="subheader">Select your school or institution so that if it has Quill Premium, your account will have access to it.</p>
          <SchoolSelector isCollege={isCollege} selectSchool={this.selectSchool}>
            {this.renderInstitutionTypeSelection()}
          </SchoolSelector>
          {!isAdmin && !isCollege && <button
            className="non-k12-link focus-on-light"
            onClick={this.handleNonK12LinkClick}
            type="button"
          >I don&#39;t teach at a U.S. K-12 school</button>}
        </div>
      </main>
    )
  }
}

export default SelectUSK12
